import { CurrentPhase, CurrentPhaseUtils } from "./CurrentPhase";
import { Phase, PhaseUtils } from "./Phase";

export interface Process {
  readonly currentPhase: CurrentPhase;
  readonly phases: Phase[];
}

export const ProcessUtils = {
  create({ currentPhase, phases }: { currentPhase: CurrentPhase; phases: Phase[] }): Process {
    return {
      currentPhase,
      phases,
    };
  },

  fromMap(map: Record<string, any>): Process {
    try {
      return ProcessUtils.create({
        currentPhase: CurrentPhaseUtils.fromMap(map["currentPhase"] ?? {}),
        phases: Array.isArray(map["phases"])
          ? map["phases"].map((e) => PhaseUtils.fromMap(e ?? {}))
          : [],
      });
    } catch (e) {
      console.error(e);
      return ProcessUtils.empty();
    }
  },

  empty(): Process {
    return ProcessUtils.create({
      currentPhase: CurrentPhaseUtils.empty(),
      phases: [],
    });
  },

  toMap(process: Process): Record<string, any> {
    return {
      currentPhase: CurrentPhaseUtils.toMap(process.currentPhase),
      phases: process.phases.map((p) => PhaseUtils.toMap(p)),
    };
  },

  toJson(process: Process): string {
    return JSON.stringify(ProcessUtils.toMap(process));
  },
};
